import React, { useEffect, useState } from 'react';
import { translate } from '@shakkerai/util-i18n';
import { Icon } from '@shakkerai/components';
import { updatePartialState, usePartialState } from '../../../store/state';

const AniInput = React.memo(() => {
  const topKeyword = usePartialState('keyword');
  const [keyword, setKeyword] = useState('');
  const [isFocus, setIsFocus] = useState(false);
  useEffect(() => {}, []);
  const handkeKeyDown = (e) => {
    if (e.key === 'Enter') {
      updatePartialState('keyword', { value: keyword });
    }
  };
  const handleInputKeyword = (e) => {
    setKeyword(e.target.value);
  };

  useEffect(() => {
    setKeyword(topKeyword.value);
  }, [topKeyword]);

  const handleClearKeyword = (e) => {
    setKeyword('');
    updatePartialState('keyword', { value: '' });
    e.stopPropagation();
  };
  return (
    <div
      style={{
        width: isFocus || keyword ? '188px' : '108px',
        transition: 'width 0.1s ease-in-out',
      }}
      className="relative bg-[#f4f6f8] flex items-center h-[34px] pl-3 rounded mr-2 border border-transparent focus-within:border-primary"
    >
      <Icon className="shk-danchuang-sousuo" fontSize={16} color="#ADADAD" />
      <input
        maxLength={40}
        value={keyword}
        placeholder={translate('common_search')}
        // style={{ width: isFocus || keyword ? '188px' : '108px' }}
        className="flex-1 mx-2 pr-4 bg-transparent text-[13px]"
        onKeyDown={handkeKeyDown}
        onChange={handleInputKeyword}
        onFocus={() => setIsFocus(true)}
        onBlur={() => setIsFocus(false)}
        onMouseDown={(e) => e.stopPropagation()}
      />
      {keyword ? (
        <button
          onClick={handleClearKeyword}
          className="absolute flex items-center justify-center z-[2] right-[5px] w-[14px] h-[14px] rounded-full bg-black/20"
        >
          <Icon className="shk-prompt-lora-guanbi scale-50" fontSize={12} color="#fff" />
        </button>
      ) : null}
    </div>
  );
});
export default AniInput;
